import ArtifactSurface from './ArtifactSurface';
import Styled from './ArtifactView.styled';

function ArtifactView() {
  return (
    <Styled.Wrapper data-testid="artifact-view">
      <ArtifactSurface />
    </Styled.Wrapper>
  );
}

export default ArtifactView;
